import { render, staticRenderFns } from "./LabelCIcon.vue?vue&type=template&id=8f4b938a&"
import script from "./LabelCIcon.vue?vue&type=script&lang=js&"
export * from "./LabelCIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports